var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"component--ribbon__nav"},_vm._l((_vm.panels),function(panel){return _c('li',{key:panel.name,class:panel.name === _vm.currentTabName ? 'nav-title__active' : null,on:{"click":function($event){return _vm.handleTabTitleClicked(panel.name)}}},[_c('span',[_vm._v("\n      "+_vm._s(panel.label || panel.name)+"\n    ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }